/* ── Moldilicious v3 — Main JS ─── */
(function(){
  'use strict';

  /* ── Nav Drawer ─────────────────────────────── */
  const burger = document.getElementById('mld-burger');
  const drawerEl = document.getElementById('mld-drawer');
  const drawerOv = document.getElementById('mld-drawer-ov');
  const drawerClose = document.getElementById('mld-drawer-close');
  if (burger && drawerEl) {
    function openNav(){document.body.classList.add('mld-nav-open');burger.setAttribute('aria-expanded','true');drawerEl.setAttribute('aria-hidden','false');drawerOv&&drawerOv.setAttribute('aria-hidden','false');if(drawerClose)drawerClose.focus();}
    function closeNav(){document.body.classList.remove('mld-nav-open');burger.setAttribute('aria-expanded','false');drawerEl.setAttribute('aria-hidden','true');drawerOv&&drawerOv.setAttribute('aria-hidden','true');burger.focus();}
    burger.addEventListener('click',()=>document.body.classList.contains('mld-nav-open')?closeNav():openNav());
    if(drawerClose)drawerClose.addEventListener('click',closeNav);
    if(drawerOv)drawerOv.addEventListener('click',closeNav);
    document.addEventListener('keydown',e=>{if(e.key==='Escape'&&document.body.classList.contains('mld-nav-open'))closeNav();});
  }

  /* ── Toast ──────────────────────────────────── */
  window.mldToast = function(msg){
    let t = document.getElementById('mld-toast');
    if(!t) return;
    if(msg) t.textContent = msg;
    t.classList.remove('show');
    void t.offsetWidth;
    t.classList.add('show');
    setTimeout(()=>t.classList.remove('show'), 2000);
  };

  /* ── Cart Count ─────────────────────────────── */
  function updateCartCount(n){
    document.querySelectorAll('.mld-cart-count').forEach(el=>{el.textContent=n;});
  }
  function fetchCartCount(){
    fetch('/cart.js').then(r=>r.json()).then(d=>updateCartCount(d.item_count)).catch(()=>{});
  }
  fetchCartCount();

  /* ── Add to Cart ────────────────────────────── */
  window.mldAddToCart = function(variantId, btn){
    if(!variantId) return;
    if(btn){ btn.disabled=true; btn.textContent='…'; }
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:variantId,quantity:1})})
      .then(r=>r.json())
      .then(()=>{
        fetchCartCount();
        mldToast('Added to bag ✓');
        if(btn){ btn.disabled=false; btn.textContent='+'; }
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      })
      .catch(()=>{
        mldToast('Added to bag ✓');
        if(btn){ btn.disabled=false; btn.textContent='+'; }
      });
  };

  /* ── Wishlist ────────────────────────────────── */
  window.mldWish = function(btn){
    const on = btn.textContent === '❤️';
    btn.textContent = on ? '🤍' : '❤️';
    btn.style.transform = 'scale(1.35)';
    setTimeout(()=>btn.style.transform='', 220);
    btn.setAttribute('aria-label', on ? 'Add to wishlist' : 'Remove from wishlist');
  };

  /* ── Product Filter ──────────────────────────── */
  window.mldFilter = function(btn, cat){
    if(!btn) return;
    document.querySelectorAll('.mld-cat').forEach(b=>b.classList.remove('on'));
    btn.classList.add('on');
    document.querySelectorAll('.mld-prod-card').forEach(c=>{
      const show = cat === 'all' || (c.dataset.cat && c.dataset.cat.includes(cat));
      c.style.display = show ? '' : 'none';
    });
    const prodSection = document.getElementById('mld-products');
    if(prodSection) prodSection.scrollIntoView({behavior:'smooth',block:'start'});
  };
  window.mldFilterSet = function(cat){
    document.body.classList.remove('mld-nav-open');
    const btn = document.querySelector(`.mld-cat[data-cat="${cat}"]`);
    mldFilter(btn, cat);
  };

  /* ── Newsletter ──────────────────────────────── */
  window.mldNlSubmit = function(e){
    e.preventDefault();
    const btn = e.target.querySelector('button[type=submit]');
    if(btn){ btn.textContent = "🎉 You're in!"; btn.disabled = true; btn.style.background = '#16a34a'; }
    setTimeout(()=>{ if(btn){ btn.textContent = 'Get 10% Off'; btn.disabled = false; btn.style.background = ''; } }, 3200);
  };

  /* ── Scroll Reveal ───────────────────────────── */
  const obs = new IntersectionObserver(entries=>{
    entries.forEach(e=>{ if(e.isIntersecting){ e.target.classList.add('on'); obs.unobserve(e.target); } });
  }, {threshold:.1, rootMargin:'0px 0px -36px 0px'});
  document.querySelectorAll('.reveal').forEach(el=>obs.observe(el));
})();
